export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'conversation_team_manage',
  'contact_manage',
  'report_manage',
  'knowledge_base_manage',
  'kanban_manage',
  'kanban_view',
  'search_view_restricted',
  'contact_phone_hide',
  'groups_view',
  'restrict_profile_edit',
  'message_delete',
];

export const CONTACT_PHONE_HIDE = 'contact_phone_hide';
export const RESTRICT_PROFILE_EDIT = 'restrict_profile_edit';
export const MESSAGE_DELETE_PERMISSION = 'message_delete';

export const ROLES = ['agent', 'administrator'];

export const CONVERSATION_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'conversation_team_manage',
];

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversation_manage';

export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  'conversation_unassigned_manage';

export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  'conversation_participating_manage';

export const CONVERSATION_TEAM_MANAGE_PERMISSIONS =
  'conversation_team_manage';

export const CONTACT_PERMISSIONS = 'contact_manage';

export const REPORTS_PERMISSIONS = 'report_manage';

export const PORTAL_PERMISSIONS = 'knowledge_base_manage';

export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  me: {
    count: 'mineCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  unassigned: {
    count: 'unAssignedCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
    ],
  },
  all: {
    count: 'allCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_PARTICIPATING_PERMISSIONS,
      CONVERSATION_TEAM_MANAGE_PERMISSIONS,
    ],
  },
  // v6.4.7: Aba Kanban desativada temporariamente — descomente para reativar
  // kanban: {
  //   count: 'kanbanCount',
  //   permissions: [...ROLES, 'kanban_view'],
  // },
  // v6.4.7: Aba Grupos — filtra conversas de grupos WhatsApp (@g.us)
  groups: {
    count: 'groupsCount',
    // v6.4.11: Apenas admin/agent padrão ou custom role com groups_view
    permissions: [...ROLES, 'groups_view'],
  },
};
